import INVENTORY_API_BASE_URL from "../../config/api";
import  { useState, useEffect, useRef } from "react";
import Table from "react-bootstrap/Table";
import Axios from "axios";
import "./BookSerial.css";
import Barcode from "react-barcode";
import { useReactToPrint } from "react-to-print";
import Spinner from "react-bootstrap/Spinner";

const BookSerial = () => {
  const [data, setData] = useState([]);
  const [details, setDetails] = useState([]);
  const [modelData, setModeldata] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [status, setStatus] = useState();
  const [barcodeRange, setBarcodeRange] = useState({ start: 1, end: 10 }); 

  const [loadingRows, setLoadingRows] = useState(
    Array(details.length).fill(false)
  );

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getOrder`).then((response) => {
      setData(response.data);
    });
  }, []);

  function formatApprovalDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const handleRowClick = (index) => {
    setSelectedRow(index);
    setLoadingRows((prevLoadingRows) => {
      const updatedLoadingRows = [...prevLoadingRows];
      updatedLoadingRows[index] = true;
      return updatedLoadingRows;
    });

    setTimeout(() => {
      setLoadingRows((prevLoadingRows) => {
        const updatedLoadingRows = [...prevLoadingRows];
        updatedLoadingRows[index] = false;
        return updatedLoadingRows;
      });
    }, 0); 
  };

  function getSkuByOrderId(orderid, index) {
    const matchingData = data.find((row) => row.orderid === orderid);
    if (matchingData) {
      const list = matchingData.updatedQuantity;
      const types = list.map((obj) => [
        obj.sku,
        obj.title,
        obj.approvedquantity,
        obj.batchid,
        obj.Medium,
        obj.edition,
      ]);
      console.log(types);
      setDetails(types);
    } else {
      setDetails([]);
    }

    setLoadingRows((prevLoadingRows) => {
      const updatedLoadingRows = [...prevLoadingRows];
      updatedLoadingRows[index] = true; 
      return updatedLoadingRows;
    });

    Axios.get(`${INVENTORY_API_BASE_URL}/getOrder/${orderid}`)
      .then((response) => {
        setModeldata(response.data);
        setLoadingRows((prevLoadingRows) => {
          const updatedLoadingRows = [...prevLoadingRows];
          updatedLoadingRows[index] = false; 
          return updatedLoadingRows;
        });
      })
      .catch((error) => {
        console.error(error);
        setLoadingRows((prevLoadingRows) => {
          const updatedLoadingRows = [...prevLoadingRows];
          updatedLoadingRows[index] = false; 
          return updatedLoadingRows;
        });
      });
  }

  const filteredData = data.filter((row) => row.ApprovalDate !== null);
  const storedValues = [];
  const barcodeid = [];
  const barcodetitle = [];
  const barcodeMedium = [];
  const barcodeedition = [];

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "barcode",
  });

  const generatePrintableBarcodes = () => {
    return storedValues
      .slice(barcodeRange.start - 1, barcodeRange.end) 
      .map((value, index) => (
        <div key={index} className="codeContainer">
          <p className="barcodetitle">{barcodetitle[0].substring(0, 30)}</p>
          <p className="barcodeMedium">
            {barcodeMedium[0]} {barcodeedition[5]}
          </p>

          <div style={{ fontFamily: "Roboto" }}>
            <Barcode
              value={value}
              height="26rem"
              width="1rem"
              fontSize="13rem"
              marginLeft="1rem"
            />
          </div>
        </div>
      ));
  };
  const givestatus = (id) => {
    Axios.put(`${INVENTORY_API_BASE_URL}/updatestatus`, {
      id: id,
     status: status,
    })
      .then(() => {
        window.location.reload(); 
      })
      .catch((err) => console.log(err));
  };

  return (
    <div style={{ marginLeft: "20rem", marginTop: "5rem" }}>
      <h4 style={{ marginBottom: "2rem" }}>Generate Book Serial Number</h4>
      <div className="serialcontainer">
        <div className="serialcontent">
          <Table style={{ width: "116rem" }} className="bookser">
            <thead>
              <tr>
                <th>Order No</th>
                <th>Received Date</th>
                <th>SKU</th>
                <th>Quantity </th>
                <th>Serial Number</th>
                <th>Vehicle No. w Date</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((row, index) => (
                <tr key={row.orderid}>
                  <td>{row.orderid}</td>
                  <td>{formatApprovalDate(row.ApprovalDate)}</td>
                  <td>{row.list.length}</td>
                  <td>
                    {row.updatedQuantity
                      .map((item) => item.approvedquantity)
                      .reduce((acc, value) => acc + value)}
                  </td>
                  <td>
                    {loadingRows[index] ? (
                      <Spinner animation="border" variant="primary" />
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => getSkuByOrderId(row.orderid, index)}
                      >
                        click
                      </button>
                    )}
                  </td>
                  <td style={{ padding: "1.5rem" }}>
                    {row.status}
                    {row.status === "" ? (
                      <div>
                        <input
                          type="text"
                           placeholder="Vehicle Number and Dispatch-Date"
                          onChange={(e) => {
                            setStatus(e.target.value);
                          }}
                        />
                        <button
                          className="approvebutton"
                          onClick={() => {
                            givestatus(row._id);
                          }}
                        >
                          update
                        </button>
                      </div>
                    ) : (
                      <div>
                        <input
                          type="text"
                          placeholder="Vehicle Number and Dispatch-Date"
                          onChange={(e) => {
                            setStatus(e.target.value);
                          }}
                        />
                        <button
                          className="approvebutton"
                          onClick={() => {
                            givestatus(row._id);
                          }}
                        >
                          update
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
      <div>
        <h2>Order Id: {modelData.orderid}</h2>
        <Table bordered>
          <thead>
            <tr>
              <th>Title</th>
              <th>SKU</th>
              <th>Medium</th>
              <th>Edition</th>
              <th>Quantity</th>
              <th>Batch ID</th>
              <th>Serial Number</th>
            </tr>
          </thead>
          <tbody>
            {details.map((val, index) => {
              const title = val[1];
              const SKU = val[0];
              const Medium = val[4];
              const edition = val[5];
              const Quantity = val[2];
              const BatchID = val[3];
              return (
                <tr
                  key={index}
                  className={selectedRow === index ? "selected" : ""}
                >
                  <td>{title}</td>
                  <td>{SKU}</td>
                  <td>{Medium}</td>
                  <td>{edition}</td>
                  <td>{Quantity}</td>
                  <td>{BatchID}</td>
                  <td>
                    {loadingRows[index] ? (
                      <Spinner animation="border" variant="primary" size="sm" />
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => handleRowClick(index)}
                      >
                        Click
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <Table>
          {selectedRow !== null && (
            <tfoot>
              <tr>
                <th>Selected Title</th>
                <th>Selected SKU</th>
                <th>Selected Batch ID</th>
                <th>Serial Number</th>
              </tr>
              {Array(details[selectedRow][2])
                .fill("")
                .map((_, index) => {
                  const selectedid = `${details[selectedRow][3]}`;
                  const value = `${selectedid}-${index + 1}`;
                  storedValues.push(value);
                  const selectedSKU = `${details[selectedRow][0]}`;
                  const selectedTitle = `${details[selectedRow][1]}`;
                  barcodeid.push(selectedid);
                  barcodetitle.push(selectedTitle);
                  const selectedMedium = `${details[selectedRow][4]}`;
                  barcodeMedium.push(selectedMedium);

                  const selectededition = `${details[selectedRow][5]}`;
                  barcodeedition.push(selectededition);
                  return (
                    <tr key={index}>
                      <td>{selectedTitle}</td>
                      <td>{selectedSKU}</td>
                      <td>{selectedid}</td>
                      <td>{value}</td>
                    </tr>
                  );
                })}
            </tfoot>
          )}
        </Table>
      </div>
      <div>
        <label htmlFor="barcodeRangeStart">Start Barcode: </label>
        <input
          type="number"
          id="barcodeRangeStart"
          value={barcodeRange.start}
          onChange={(e) =>
            setBarcodeRange({
              ...barcodeRange,
              start: parseInt(e.target.value),
            })
          }
          min="1"
          max={storedValues.length}
        />
        <label htmlFor="barcodeRangeEnd">End Barcode: </label>
        <input
          type="number"
          id="barcodeRangeEnd"
          value={barcodeRange.end}
          onChange={(e) =>
            setBarcodeRange({ ...barcodeRange, end: parseInt(e.target.value) })
          }
          min="1"
          max={storedValues.length}
        />
      </div>
      <div ref={componentRef}>
        <div className="serialbarcode">{generatePrintableBarcodes()}</div>
      </div>

      <button className="printbtn" onClick={handlePrint}>
        Print Barcode
      </button>
    </div>
  );
};

export default BookSerial;
